import './PardotRuleReference.scss';
import { ifClickHandler } from '@lib/events';
import { lowerFirst } from '@sonar-software/sonar-ts-lib';
import { SonarRecord } from '@ui/records';
import React, { useMemo } from 'react';
export const PardotRuleReference = ({ entity, onRuleClick }) => {
    const { displayName, sonarObjectId, sonarObjectType } = entity;
    const ruleReferenceType = lowerFirst(entity.sonarObjectType);
    const clickable = Boolean(sonarObjectType);
    const handleOnClick = useMemo(() => ifClickHandler(onRuleClick, entity), [entity, onRuleClick]);
    return (React.createElement("div", { className: 'pardot-rule-reference' },
        React.createElement(SonarRecord, { name: displayName, onClick: clickable ? handleOnClick : undefined, sonarObjectId: sonarObjectId, sonarObjectType: ruleReferenceType })));
};
